// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1PB0S","col":"styles_col__173Ht"};